module.exports = __webpack_public_path__ + "img/chrome_settings.084db889.png";